<h2 mat-dialog-title>
    {{'RANKINGLISTS.SELECT_RANKING_LIST' | translate | uppercase }}
  </h2>

        <div mat-dialog-content >

            <mat-selection-list #playerlist style="height: 350px; " [multiple]="false" >
                @for (list of playerlists(); track list.ListId) {
                
               <!--      <mat-divider *ngIf="team.Players.length>0"></mat-divider> -->
                   <!--  <label *ngIf="team.Players.length>0" >{{team.team.LevelName}}</label><br/> -->
                    
                    <mat-list-option  style="height: 40px;" [value]="list.ListId" >        
                        
                        <h4 mat-line>{{list.Description}}</h4>
                  <!--   <span mat-line>{{player.Player.DateOfBirth | date:'yyyy-MM-dd'}}</span>  -->
                    </mat-list-option>
                
                }
                @empty {
                    <label>{{'RANKINGLISTS.NOLISTSFOUND' | translate | uppercase }}</label>
                }
            </mat-selection-list>
          
        </div>
      
  <div mat-dialog-actions>

      <button mat-button [disabled]="!isSelected(playerlist)" [mat-dialog-close]="selectedListId(playerlist)" cdkFocusInitial >{{'GENERAL.SELECT' | translate | uppercase }}</button>
      <button mat-button [mat-dialog-close]="false" >{{'GENERAL.CANCEL' | translate | uppercase }}</button>
    
  
  </div>
